import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ onMenuClick, scrolled }) => { // Receive scrolled prop

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`} id="header">
      <div className="hamburger" id="hamburger" aria-label="Open menu" role="button" tabIndex="0" onClick={onMenuClick}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="brand" aria-label="PineRidge Hotel" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
          <img src="/logo.png" alt="Pineridge Hotel Logo" style={{ marginRight: '10px', height: '30px', opacity: scrolled ? 1 : 0, transition: 'opacity 0.3s ease-in-out' }} />
          <span style={{ position: 'relative', display: 'inline-block', letterSpacing: '0.1em' }}>
            PINERIDGE HOTEL
          </span>
        </Link>
      </div>
      <div className="header-spacer"></div>
    </header>
  );
};

export default Header;
